import React, { useState } from "react";
import ContentFetch from "../../components/Fetch/ContentFetch";
import { Helmet } from "react-helmet";
import TvGuideSchedule from "./TvGuideSchedule";
import TvGuideChannelList from "./TvGuideChannelList";
import { SignInModal, UpgradeModal, TrialProgressModal } from "../../components/Modals";
import { withStore } from "../../store";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import { Analytics } from "../../utilities";
import "./TvGuide.scss"
import { Constants, AuthorizeLiveplayer } from "../../utilities";

const TvGuide: React.FunctionComponent<any> = (props) => {
  let path = props.location.pathname.split('/');
  path = path[path.length - 1];
  let channelIndex = Constants.TvGuidePaths.indexOf(path)
  const [selected, setSelected] = useState(channelIndex > -1 ? channelIndex : 0);
  const [showPrompt, setshowPrompt] = useState("");

  const handleLiveClick = async (channel) => {
    AuthorizeLiveplayer(
      props.isAbroad,
      props.enableAbroadBanner,
      setshowPrompt,
      props.store.country,
      Constants.LiveChannels[selected],
      channel,
      props.playLiveVideo
    );
  }

  return (
    <ContentFetch onComplete={Analytics.pageViewTvGuide}>
      {(error, channels) => {


        // Define the titles to keep &&  // Define custom order
        const validTitles = ["CBeebies", "BBC Earth", "BBC Lifestyle"];
        const customOrder = { "CBeebies": 1, "BBC Earth": 2, "BBC Lifestyle": 3 };

        // Filter the array to only include the three specific titles && Sort the filtered data based on the custom order
        const filteredData = channels
        ? channels
            .filter(item => validTitles.includes(item.title))
            .sort((a, b) => customOrder[a.title] - customOrder[b.title])
        : [];

        return (
          (!(filteredData.length > 0)  || error) ?
            null :
            <div>
              <Helmet>
                <title>{`BBC Player | Tv Guide`}</title>
              </Helmet>
              {filteredData &&
                <React.Fragment>
                  <div className="Tv_Guide">
                    <div className="Tv_Guide_Header"><span>TV Guide</span></div>
                    <TvGuideChannelList channels={filteredData} selected={selected} setSelected={setSelected}></TvGuideChannelList>
                    <TvGuideSchedule handleLiveClick={handleLiveClick} channelIndex={selected} channel={filteredData[selected]}></TvGuideSchedule>
                  </div>
                  {showPrompt === Constants.Prompts[0] && <SignInModal onClose={() => { setshowPrompt("") }} />}
                  {showPrompt === Constants.Prompts[2] && <TrialProgressModal onClose={() => { setshowPrompt("") }} />}
                  {showPrompt === Constants.Prompts[1] && <UpgradeModal onClose={() => setshowPrompt("")} />}
                </React.Fragment>}
            </div>
        )
      }}
    </ContentFetch>
  )
}

export default compose<any>(withRouter, withStore)(TvGuide);
